import React from 'react';
import Link from 'next/link';
import l from '../../../helpers/lang';
import HeartIcon from '../../icons/HeartIcon';

const POSTER_LINK = 'https://joinposter.com/?ref=qr_client_page&utm_source=qr&utm_medium=site&utm_campaign=qr_client_page';

export default function Copyright() {
  return (
    <div className="pb-5 text-muted text-center">
      <span className="me-1">{l('qr.tableHash/footerCopyright.labelMadeWith')}</span>
      <HeartIcon />
      <span className="mx-1">{l('qr.tableHash/footerCopyright.labelBy')}</span>
      <Link href={POSTER_LINK} target="_blank" rel="noreferrer" className="text-muted text-decoration-none">
        Poster POS
      </Link>
    </div>
  );
}
